/**
 * Aztrix
 * Smart address book for individuals and organisations, respecting privacy.
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Query {
  query?: string;
  propertyTypes?: Array<Query.PropertyTypesEnum>;
  range?: number;
}
export namespace Query {
  export type PropertyTypesEnum =
    | 'USERNAME'
    | 'FIRST_NAME'
    | 'MIDDLE_NAME'
    | 'LAST_NAME'
    | 'NAME'
    | 'AVATAR'
    | 'GENDER'
    | 'BIRTHDAY'
    | 'FOUNDED'
    | 'DISSOLVED'
    | 'DAY'
    | 'MONTH'
    | 'YEAR'
    | 'EMAIL'
    | 'MOBILE_PHONE'
    | 'PHONE'
    | 'FAX'
    | 'WEBSITE'
    | 'BIC'
    | 'JOB_TITLE'
    | 'INDUSTRY'
    | 'GROUP'
    | 'REGION'
    | 'ADDRESS'
    | 'STREET'
    | 'COUNTRY'
    | 'BUILDING'
    | 'BOX'
    | 'LOCALITY'
    | 'NUMBER'
    | 'ZIP'
    | 'DISTRICT'
    | 'PROVINCE'
    | 'SUBURB'
    | 'STATE'
    | 'COUNTY'
    | 'LAT_LONG'
    | 'FACEBOOK'
    | 'YOUTUBE'
    | 'INSTAGRAM'
    | 'WHATSAPP'
    | 'WECHAT'
    | 'TIKTOK'
    | 'FACEBOOK_MESSENGER'
    | 'TELEGRAM'
    | 'SNAPCHAT'
    | 'PINTEREST'
    | 'TWITTER'
    | 'REDDIT'
    | 'LINKEDIN'
    | 'VIMEO'
    | 'DISCORD'
    | 'TWITCH'
    | 'TUMBLR'
    | 'MASTODON'
    | 'PATREON'
    | 'KICKSTARTER'
    | 'INDIEGOGO'
    | 'GOFUNDME'
    | 'TAKEAWAY'
    | 'UBEREATS'
    | 'DELIVEROO'
    | 'SHIPTO'
    | 'WEIBO'
    | 'QQ'
    | 'KUAISHOU'
    | 'QZONE'
    | 'SKYPE'
    | 'NOTE'
    | 'ORGANISATION_NAME'
    | 'LEGAL_NAME'
    | 'LEGAL_FORM'
    | 'LEGAL_ID'
    | 'COMPANY_NUMBER'
    | 'JURISDICTION'
    | 'IMPORT_SOURCE'
    | 'PROPOSAL'
    | 'CATEGORY'
    | 'OPENING_HOURS'
    | 'CUSTOM'
    | 'FILE'
    | 'IMAGE'
    | 'FILE_KEY'
    | 'FILE_NAME'
    | 'TERMS_AND_CONDITIONS'
    | 'PRIVACY_POLICY'
    | 'DOCUMENT'
    | 'DOCUMENT_NAME'
    | 'ORGANISATION_TYPE';
  export const PropertyTypesEnum = {
    USERNAME: 'USERNAME' as PropertyTypesEnum,
    FIRST_NAME: 'FIRST_NAME' as PropertyTypesEnum,
    MIDDLE_NAME: 'MIDDLE_NAME' as PropertyTypesEnum,
    LAST_NAME: 'LAST_NAME' as PropertyTypesEnum,
    NAME: 'NAME' as PropertyTypesEnum,
    AVATAR: 'AVATAR' as PropertyTypesEnum,
    GENDER: 'GENDER' as PropertyTypesEnum,
    BIRTHDAY: 'BIRTHDAY' as PropertyTypesEnum,
    FOUNDED: 'FOUNDED' as PropertyTypesEnum,
    DISSOLVED: 'DISSOLVED' as PropertyTypesEnum,
    DAY: 'DAY' as PropertyTypesEnum,
    MONTH: 'MONTH' as PropertyTypesEnum,
    YEAR: 'YEAR' as PropertyTypesEnum,
    EMAIL: 'EMAIL' as PropertyTypesEnum,
    MOBILE_PHONE: 'MOBILE_PHONE' as PropertyTypesEnum,
    PHONE: 'PHONE' as PropertyTypesEnum,
    FAX: 'FAX' as PropertyTypesEnum,
    WEBSITE: 'WEBSITE' as PropertyTypesEnum,
    BIC: 'BIC' as PropertyTypesEnum,
    JOB_TITLE: 'JOB_TITLE' as PropertyTypesEnum,
    INDUSTRY: 'INDUSTRY' as PropertyTypesEnum,
    GROUP: 'GROUP' as PropertyTypesEnum,
    REGION: 'REGION' as PropertyTypesEnum,
    ADDRESS: 'ADDRESS' as PropertyTypesEnum,
    STREET: 'STREET' as PropertyTypesEnum,
    COUNTRY: 'COUNTRY' as PropertyTypesEnum,
    BUILDING: 'BUILDING' as PropertyTypesEnum,
    BOX: 'BOX' as PropertyTypesEnum,
    LOCALITY: 'LOCALITY' as PropertyTypesEnum,
    NUMBER: 'NUMBER' as PropertyTypesEnum,
    ZIP: 'ZIP' as PropertyTypesEnum,
    DISTRICT: 'DISTRICT' as PropertyTypesEnum,
    PROVINCE: 'PROVINCE' as PropertyTypesEnum,
    SUBURB: 'SUBURB' as PropertyTypesEnum,
    STATE: 'STATE' as PropertyTypesEnum,
    COUNTY: 'COUNTY' as PropertyTypesEnum,
    LAT_LONG: 'LAT_LONG' as PropertyTypesEnum,
    FACEBOOK: 'FACEBOOK' as PropertyTypesEnum,
    YOUTUBE: 'YOUTUBE' as PropertyTypesEnum,
    INSTAGRAM: 'INSTAGRAM' as PropertyTypesEnum,
    WHATSAPP: 'WHATSAPP' as PropertyTypesEnum,
    WECHAT: 'WECHAT' as PropertyTypesEnum,
    TIKTOK: 'TIKTOK' as PropertyTypesEnum,
    FACEBOOK_MESSENGER: 'FACEBOOK_MESSENGER' as PropertyTypesEnum,
    TELEGRAM: 'TELEGRAM' as PropertyTypesEnum,
    SNAPCHAT: 'SNAPCHAT' as PropertyTypesEnum,
    PINTEREST: 'PINTEREST' as PropertyTypesEnum,
    TWITTER: 'TWITTER' as PropertyTypesEnum,
    REDDIT: 'REDDIT' as PropertyTypesEnum,
    LINKEDIN: 'LINKEDIN' as PropertyTypesEnum,
    VIMEO: 'VIMEO' as PropertyTypesEnum,
    DISCORD: 'DISCORD' as PropertyTypesEnum,
    TWITCH: 'TWITCH' as PropertyTypesEnum,
    TUMBLR: 'TUMBLR' as PropertyTypesEnum,
    MASTODON: 'MASTODON' as PropertyTypesEnum,
    PATREON: 'PATREON' as PropertyTypesEnum,
    KICKSTARTER: 'KICKSTARTER' as PropertyTypesEnum,
    INDIEGOGO: 'INDIEGOGO' as PropertyTypesEnum,
    GOFUNDME: 'GOFUNDME' as PropertyTypesEnum,
    TAKEAWAY: 'TAKEAWAY' as PropertyTypesEnum,
    UBEREATS: 'UBEREATS' as PropertyTypesEnum,
    DELIVEROO: 'DELIVEROO' as PropertyTypesEnum,
    SHIPTO: 'SHIPTO' as PropertyTypesEnum,
    WEIBO: 'WEIBO' as PropertyTypesEnum,
    QQ: 'QQ' as PropertyTypesEnum,
    KUAISHOU: 'KUAISHOU' as PropertyTypesEnum,
    QZONE: 'QZONE' as PropertyTypesEnum,
    SKYPE: 'SKYPE' as PropertyTypesEnum,
    NOTE: 'NOTE' as PropertyTypesEnum,
    ORGANISATION_NAME: 'ORGANISATION_NAME' as PropertyTypesEnum,
    LEGAL_NAME: 'LEGAL_NAME' as PropertyTypesEnum,
    LEGAL_FORM: 'LEGAL_FORM' as PropertyTypesEnum,
    LEGAL_ID: 'LEGAL_ID' as PropertyTypesEnum,
    COMPANY_NUMBER: 'COMPANY_NUMBER' as PropertyTypesEnum,
    JURISDICTION: 'JURISDICTION' as PropertyTypesEnum,
    IMPORT_SOURCE: 'IMPORT_SOURCE' as PropertyTypesEnum,
    PROPOSAL: 'PROPOSAL' as PropertyTypesEnum,
    CATEGORY: 'CATEGORY' as PropertyTypesEnum,
    OPENING_HOURS: 'OPENING_HOURS' as PropertyTypesEnum,
    CUSTOM: 'CUSTOM' as PropertyTypesEnum,
    FILE: 'FILE' as PropertyTypesEnum,
    IMAGE: 'IMAGE' as PropertyTypesEnum,
    FILE_KEY: 'FILE_KEY' as PropertyTypesEnum,
    FILE_NAME: 'FILE_NAME' as PropertyTypesEnum,
    TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS' as PropertyTypesEnum,
    PRIVACY_POLICY: 'PRIVACY_POLICY' as PropertyTypesEnum,
    DOCUMENT: 'DOCUMENT' as PropertyTypesEnum,
    DOCUMENT_NAME: 'DOCUMENT_NAME' as PropertyTypesEnum,
    ORGANISATION_TYPE: 'ORGANISATION_TYPE' as PropertyTypesEnum,
  };
}
